import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'prop-types';
import styled from 'styled-components';
import { getDropShadowByElevation } from '../../styles/elevation.js';
import { getModeStyles } from '../../styles/mode.js';
import { getSpacing } from '../../styles/spacing.js';

var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "sc-1xpbfv1-0"
})(function (_ref) {
  var borderRadius = _ref.borderRadius,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 1 : _ref$borderWidth,
      elevation = _ref.elevation,
      elevationHover = _ref.elevationHover,
      padding = _ref.padding,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "light" : _ref$variant;
  return _objectSpread(_objectSpread({}, getModeStyles(variant)), {}, {
    borderRadius: getSpacing(borderRadius),
    borderWidth: borderWidth,
    borderStyle: "solid",
    boxShadow: getDropShadowByElevation(elevation),
    ":hover": {
      boxShadow: getDropShadowByElevation(elevationHover)
    },
    padding: getSpacing(padding)
  });
});

export { Box };
